import { render } from "./AccreditationsSection.vue?vue&type=template&id=d5edc4e0&scoped=true"
import script from "./AccreditationsSection.vue?vue&type=script&lang=js"
export * from "./AccreditationsSection.vue?vue&type=script&lang=js"

import "./AccreditationsSection.vue?vue&type=style&index=0&id=d5edc4e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5edc4e0"]])

export default __exports__